import { take, catchError, map, switchMap } from 'rxjs/operators';
import { getSelectedBusinessLineAndShippingCondition, OrderBuilderState } from './../../../../../reducers/index';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  JobsiteLoadAction,
  JobsiteLoadCompleteAction,
  JobsiteLoadFailAction,
  LOAD,
} from '../../../actions/jobsite-actions/jobsite.actions';
import {
  IShipmentLocationResponse,
  ShipmentLocationsService,
  IShipmentLocationRequest,
  COUNTRY_CODE,
} from '@cemex-core/cmx-api';
import { getRmsModifyFlag } from './../../../../rms-specification/selectors/rms-modify-flag.selectors';
import { PRODUCT_LINE_ID } from '@ordersnproducts/modules/shared/constants/product-lines-ids';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * An effect which monitors the actions$ Observable for (job-site) LOAD operations
 * and then
 */
@Injectable()
export class JobsiteLoadEffects implements IEffect {
  jobsiteLoad$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<JobsiteLoadAction>(LOAD),
      switchMap((action) =>
        this.store.pipe(
          select((state) => ({
            customer: getLegalEntity(state),
            response: getSelectedBusinessLineAndShippingCondition(state),
            isModify: getRmsModifyFlag(state),
          })),
          take(1),
          map((selectedState) => ({ action, ...selectedState })),
        ),
      ),
      switchMap(({ action, customer, response, isModify }) => {
        const request: IShipmentLocationRequest = action.payload;

        if (!isModify?.modifyFlag) {
          if (
            (response?.productLineId === PRODUCT_LINE_ID.READY_MIX &&
              customer.countryCode.trim() === COUNTRY_CODE.FRANCE) ||
            parseInt(
              _safe(() => response.productLineId.toString()),
              10,
            ) === PRODUCT_LINE_ID.AGGREGATES
          ) {
            request.shippingConditionId = response?.shippingConditionId;
          }
        }

        return this.shipmentLocationService.getShipmentLocations(request).pipe(
          map((shipmentLocationResponse: IShipmentLocationResponse) => {
            return new JobsiteLoadCompleteAction(shipmentLocationResponse);
          }),
          catchError((error) => of(new JobsiteLoadFailAction(error))),
        );
      }),
    ),
  );

  /**
   *
   * @param {Store<OrderBuilderState>} store the usual in-memory store of application state.
   * @param {Actions} actions$ an Observable subclass which deals with actions
   *                           taken by or in the application
   * @param {ShipmentLocationsService} shipmentLocationService
   */
  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private shipmentLocationService: ShipmentLocationsService,
  ) {}
}
